// @flow
import React, { PureComponent } from 'react';
import type { Pratique, PratiqueAgenda } from 'types/Club';

type Props = {
  practices: Pratique[]
};

class ClubPractices extends PureComponent<Props> {
  isMobileHidden = (agenda: PratiqueAgenda[], indexAgenda: number) => {
    if (indexAgenda === agenda.length - 1) {
      return 'mobile-hidden';
    } else if (indexAgenda === 0) {
      return 'no-border';
    } else {
      return 'no-border mobile-hidden';
    }
  };

  renderPractices = () => {
    const pratiques = this.props.practices.sort((a, b) => {
      return parseInt(a.Pratique.id, 10) - parseInt(b.Pratique.id, 10);
    });
    return pratiques.map<any>((practice, index) => {
      if (practice.Agenda && practice.Agenda.length > 1) {
        const horaires = [];
        const jours = [];
        return practice.Agenda.sort((a, b) => {
          return parseInt(a.jour, 10) - parseInt(b.jour, 10);
        })
          .sort((a, b) => {
            if (a.jour === b.jour && (a.heureDebut || '23:00:00') < (b.heureDebut || '23:00:00')) return -1;
            if (a.jour === b.jour && (a.heureDebut || '23:00:00') > (b.heureDebut || '23:00:00')) return 1;
            return 0;
          })
          .map((agenda, indexAgenda) => {
            const id =
              (agenda.jourNom || 'lundi') + (agenda.heureDebut || '00:00:00') + (agenda.heureFin || '00:00:00');
            if (horaires.indexOf(id) !== -1) {
              return null;
            }
            if (jours.indexOf(agenda.jourNom) !== -1 && !agenda.heureDebut) {
              return null;
            }
            horaires.push(id);
            jours.push(agenda.jourNom);
            const lieu = agenda.Adresse && (agenda.Adresse.complement || agenda.Adresse.voie);

            return (
              <tr key={'agenda_' + indexAgenda} className={'pratique_' + indexAgenda}>
                <td className={this.isMobileHidden(practice.Agenda, indexAgenda)} data-title="Type de pratique">
                  {indexAgenda === 0 && practice.Pratique.nom === 'Rugby à 5'
                    ? 'Rugby à 5 Loisir - Bien être'
                    : practice.Pratique.nom}
                </td>
                <td className={this.isMobileHidden(practice.Agenda, indexAgenda)} data-title="Responsable">
                  {indexAgenda === 0 &&
                    practice.Personne &&
                    practice.Personne.id &&
                    practice.Personne.prenom + ' ' + practice.Personne.nom}
                </td>
                <td data-title="jour">{agenda.jourNom.charAt(0).toUpperCase() + agenda.jourNom.slice(1)}</td>
                <td data-title="horaire">
                  {(agenda.heureDebut ? agenda.heureDebut.substr(0, 5) : '') +
                    (agenda.heureFin ? '-' + agenda.heureFin.substr(0, 5) : '')}
                </td>
                <td data-title="lieu">
                  {lieu && (
                    <span>
                      <a
                        href={`https://www.google.com/maps/dir/?api=1&destination=${
                          agenda.Adresse.complement ? agenda.Adresse.complement : ''
                        }+${agenda.Adresse.voie ? agenda.Adresse.voie : ''}+${
                          agenda.Adresse.localite ? agenda.Adresse.localite : ''
                        }`}
                        title={"Visualiser l'adresse du club sur Google Maps (nouvel onglet)"}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="icon icon-place is-inline" />
                        {lieu}
                      </a>
                    </span>
                  )}
                </td>
              </tr>
            );
          });
      }

      const lieu =
        practice.Agenda &&
        practice.Agenda.length > 0 &&
        practice.Agenda[0] &&
        practice.Agenda[0].Adresse &&
        (practice.Agenda[0].Adresse.complement || practice.Agenda[0].Adresse.voie);
      return (
        <tr key={index}>
          <td className="" data-title="Type de pratique">
            {practice.Pratique.nom === 'Rugby à 5' ? 'Rugby à 5 Loisir - Bien être' : practice.Pratique.nom}
          </td>
          <td className="" data-title="Responsable">
            {practice.Personne && practice.Personne.id && practice.Personne.prenom + ' ' + practice.Personne.nom}
          </td>
          <td data-title="jour">
            {practice.Agenda &&
              practice.Agenda[0] &&
              practice.Agenda[0].jourNom.charAt(0).toUpperCase() + practice.Agenda[0].jourNom.slice(1)}
          </td>
          <td data-title="horaire">
            {practice.Agenda &&
              practice.Agenda[0] &&
              practice.Agenda[0].heureDebut &&
              practice.Agenda[0].heureDebut.substr(0, 5) +
                '-' +
                (practice.Agenda[0].heureFin ? '-' + practice.Agenda[0].heureFin.substr(0, 5) : '')}
          </td>
          <td data-title="lieu">
            {lieu && (
              <span>
                <a
                  href={`https://www.google.com/maps/dir/?api=1&destination=${
                    practice.Agenda[0].Adresse.complement ? practice.Agenda[0].Adresse.complement + '+' : ''
                  }${practice.Agenda[0].Adresse.voie ? practice.Agenda[0].Adresse.voie : ''}+${
                    practice.Agenda[0].Adresse.localite ? practice.Agenda[0].Adresse.localite : ''
                  }`}
                  title={"Visualiser l'adresse du club sur Google Maps (nouvel onglet)"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="icon icon-place is-inline" />
                  {lieu}
                </a>
              </span>
            )}
          </td>
        </tr>
      );
    });
  };
  render() {
    if (this.props.practices.length === 0) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="practices-table box box--smoke mt-4 mb-md-7">
          <table className="table" style={{ marginTop: 0, marginBottom: 0 }}>
            <thead>
              <tr>
                <th>Type de pratique</th>
                <th>Responsable</th>
                <th>Jour</th>
                <th>Horaire</th>
                <th>Lieu</th>
              </tr>
            </thead>
            <tbody>{this.renderPractices()}</tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}

export default ClubPractices;
